import request from '@/util/axios.js'
// 首次获取deviceId
export function firstLogin(data) {
    return request({
        url: `/account/time/get.json`,
        method: 'post',
        params: data
    })
}
// 登录
export function customLoginAction(data) {
    return request({
        url: `/account/pluser/login.json`,
        method: 'post',
        params: data
    })
}
// 第三方登录
export function thirdLoginAction(data) {
    return request({
        url: `/account/pluser/login_by_third.json`,
        method: 'post',
        params: data
    })
}
// 获取用户信息
export function userInfo(data) {
    return request({
        url: `/account/pluser/get.json`,
        method: 'post',
        params: data
    })
}
// 邮箱登录
export function mailLogin(data) {
    return request({
        url: `/account/pluser/login_by_pwd.json`,
        method: 'post',
        params: data
    })
}
// 重置邮箱密码
export function resetEmailPassword(data) {
    return request({
        url: `/account/pluser/reset_pwd.json`,
        method: 'post',
        params: data
    })
}
// 邮箱账号注册
export function bindChannel(data) {
    return request({
        url: `/account/bind/execute.json`,
        method: 'post',
        params: data
    })
}
// 发送验证码
export function sendCode(data) {
    return request({
        url: `/account/verify_code/send.json`,
        method: 'post',
        params: data
    })
}
// token登录
export function tokenLogin(data) {
    return request({
        url: `/account/pluser/login_by_token.json`,
        method: 'post',
        params: data
    })
}
// 解除绑定
export function removeBind(data) {
    return request({
        url: `/account/bind/unbind.json`,
        method: 'post',
        params: data
    })
}
// 判断是否邮箱已经注册
export function isRegister(data) {
    return request({
        url: `/account/bind/check.json`,
        method: 'post',
        params: data
    })
}

// 日志埋点上报
export function pcLogReport(data) {
    return request({
        url: `/log/sdk/send_batch.json`,
        method: 'post',
        retry: 2,
        data
    })
}
// 获取角色列表
export function getRoleList(data) {
    return request({
        url: `/account/role/list.json`,
        method: 'post',
        data: data
    })
}
// 获取城市IP
export function cityIP(data) {
    return request({
        url: `/log/common/get_ip.json`,
        method: 'post',
        data: data
    })
}
// 退出登录
export function logoutApi(data) {
    return request({
        url: `/account/pluser/logout.json`,
        method: 'post',
        data: data
    })
}
